import axiosConfig from "../app/axiosConfig"
import {
  ADD_CATEGORY_API,
  CATEGORY_LIST_API,
  UPDATE_CATEGORY_API,
} from "../constants/apis"
import {
  addCategoryPayloadType,
  fetchCategoryListPayloadType,
  updateCategoryPayloadType,
} from "../slices/categorySlice"

import {
  categoryFilterService,
  createCategoryDTO,
  updateCategoryDTO,
} from "../utils/categoryHelper"
import { computeRoute } from "../utils/compute-route"

export const fetchCategoryListService = (
  payload: fetchCategoryListPayloadType,
) => {
  const parameters = categoryFilterService(payload)
  return axiosConfig.get(
    computeRoute(CATEGORY_LIST_API, {
      levelId: payload.level,
    }),
    { params: parameters },
  )
}

export const createCategoryService = (action: addCategoryPayloadType) =>
  axiosConfig.post(ADD_CATEGORY_API, createCategoryDTO(action))

export const updateCategoryService = (action: updateCategoryPayloadType) =>
  axiosConfig.patch(UPDATE_CATEGORY_API(action.id), updateCategoryDTO(action))
